var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBotoneraPersona(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2966_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 29C15.9919 29 3 32.35 3 39V44H42V39C42 32.35 29.0081 29 22.5 29Z",
    fill: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1851 14H32.8149C33.4679 14 34 13.472 34 12.824V12.776C34 12.128 33.4679 11.6 32.8149 11.6H32.1619C32.1619 8.048 30.2029 5 27.3249 3.32V5.6C27.3249 6.272 26.7928 6.8 26.1157 6.8C25.4385 6.8 24.9064 6.272 24.9064 5.6V2.336C24.1325 2.144 23.3344 2 22.4879 2C21.6414 2 20.8433 2.144 20.0694 2.336V5.6C20.0694 6.272 19.5373 6.8 18.8601 6.8C18.183 6.8 17.6509 6.272 17.6509 5.6V3.32C14.7729 5 12.8139 8.048 12.8139 11.6H12.1851C11.5321 11.6 11 12.128 11 12.776V12.848C11 13.472 11.5321 14 12.1851 14Z",
    fill: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 24C27.0777 24 30.8925 21.0133 32 17H13C14.1075 21.0133 17.9223 24 22.5 24Z",
    fill: "#EDF0F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2966_303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotoneraPersona);
export default __webpack_public_path__ + "static/media/botoneraPersona.3dff95e5.svg";
export { ForwardRef as ReactComponent };